<template>
    <component :is="component"/>
</template>

<script>

    import {mapState} from "vuex";

    import SetupResponseRedirect from "./SetupResponseRedirect";
    import SetupResponseSepa from "./SetupResponseSepa";
    import SetupResponsePost from "./SetupResponsePost";
    import SetupResponseEbanxVoucher from "./SetupResponseEbanxVoucher";
    import SetupResponseAdyenVoucher from "./SetupResponseAdyenVoucher";
    import SetupResponsePayGolVoucher from "./SetupResponsePayGolVoucher";

    export default {
        name: "SetupResponse",
        computed: {
            ...mapState({
                component: state => state.payment.setupResponse.component,
            })
        },
        components: {
            SetupResponseRedirect,
            SetupResponseSepa,
            SetupResponsePost,
            SetupResponseEbanxVoucher,
            SetupResponseAdyenVoucher,
            SetupResponsePayGolVoucher
        }
    }

</script>
